import api from '../utils/api';

export async function listContactsAdmin({ page = 1, perPage = 20, agentId = null, search = null } = {}) {
  const params = { page, per_page: perPage };
  if (agentId) {
    params.agent_id = agentId;
  }
  if (search) {
    params.search = search;
  }
  const { data } = await api.get('/admin/contacts', { params });
  return data;
}

export async function createContactAdmin({ externalId, agentId }) {
  const { data } = await api.post('/admin/contacts', {
    external_id: externalId,
    agent_id: agentId,
  });
  return data;
}

export async function getContactAdmin(contactId) {
  const { data } = await api.get(`/admin/contacts/${contactId}`);
  return data;
}

export async function resetContactAdmin(contactId) {
  const { data } = await api.post(`/admin/contacts/${contactId}/reset`);
  return data;
}

export async function updateContactContextAdmin(contactId, progressiveSummary) {
  const { data } = await api.patch(`/admin/contacts/${contactId}/context`, {
    progressive_summary: progressiveSummary,
  });
  return data;
}

export async function updateContactOnboardingAdmin(
  contactId,
  { onboardingData, onboardingCompleted } = {}
) {
  const body = {};
  if (onboardingData !== undefined) {
    body.onboarding_data = onboardingData;
  }
  if (onboardingCompleted !== undefined) {
    body.onboarding_completed = onboardingCompleted;
  }
  const { data } = await api.patch(`/admin/contacts/${contactId}/onboarding`, body);
  return data;
}

export async function listContactSessionMessagesAdmin(
  contactId,
  sessionId,
  { page = 1, perPage = 100 } = {}
) {
  const { data } = await api.get(`/admin/contacts/${contactId}/messages`, {
    params: {
      session_id: sessionId,
      page,
      per_page: perPage,
    },
  });
  return data;
}

export async function closeContactSessionAdmin(contactId, sessionId) {
  const { data } = await api.post(
    `/admin/contacts/${contactId}/sessions/${sessionId}/close`
  );
  return data;
}
